import { type FC, Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Loader, LoaderMode } from "components/Loader/Loader";

const Element = lazy(async () => await import("../../components/SignUp/gb/SignUp"));

export const SignUpRoutes: FC = () => (
  <Routes>
    <Route
      index
      element={
        <Suspense fallback={<Loader size="xxl" mode={LoaderMode.Splashscreen} />}>
          <Element />
        </Suspense>
      }
    />
  </Routes>
);
